module.exports = __webpack_public_path__ + "img/step2-Voip.6ea46c5d.png";